module.exports = function view (state, actions) {
  return h('div', { class: 'field has-addons' }, [
    h('p', { class: 'control' }, h('button', { class: 'button', onclick: function (e) { actions.down() }, disabled: (!state.counter) }, '-')),
    h('p', { class: 'control' }, h('input', { class: 'input', type: 'text', value: (state.counter), readonly: 'readonly' })),
    h('p', { class: 'control' }, h('button', { class: 'button', onclick: function (e) { actions.up() }, disabled: (state.max && state.counter >= state.max) }, '+'))
  ])
}
